import { render, staticRenderFns } from "./OrderCodeDetails.vue?vue&type=template&id=28799e06&"
import script from "./OrderCodeDetails.vue?vue&type=script&lang=js&"
export * from "./OrderCodeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28799e06')) {
      api.createRecord('28799e06', component.options)
    } else {
      api.reload('28799e06', component.options)
    }
    module.hot.accept("./OrderCodeDetails.vue?vue&type=template&id=28799e06&", function () {
      api.rerender('28799e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ReviewOrder/OrderCodeDetails.vue"
export default component.exports